<div class="footer">
    <div class="content-width">
        <div class="pre-login-footer">
            <ul class="horizontal-list-link">
                <li>
                    <a [routerLink]="['/legalpage/accessadvice']" target="_blank">
                        <body-text class="font-light medium-size"><span translate="LegalPage.AccessAdviceLink"></span></body-text>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/legalpage/cookies']" target="_blank">
                        <body-text class="font-light medium-size"><span translate="LegalPage.CookiesLink"></span></body-text>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/legalpage/privacypolicy']" target="_blank">
                        <body-text class="font-light medium-size"><span translate="LegalPage.PrivacyPolicyLink"></span></body-text>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/legalpage/termsofuse']" target="_blank">
                        <body-text class="font-light medium-size"><span translate="LegalPage.TermsOfUseLink"></span></body-text>
                    </a>
                </li>
                <li class="no-link">
                    <body-text class="font-light medium-size">Best viewed in Google Chrome and Mozilla Firefox.</body-text>
                </li>
            </ul>

            <div>
                <body-text class="font-light">Powered by&nbsp;</body-text>
                <body-text class="font-bold">BI WORLDWIDE</body-text>
            </div>

        </div>
    </div>
</div>